import config from "../config";

export const reducerLoadInitialUserController = () => {
  let user = localStorage.getItem(config.localStorage.user);

  if (user) {
    return JSON.parse(user);
  }
  return null;
};
